import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {BrowserRouter as Router, Link, Route, Switch} from 'react-router-dom';
/* Tax */
import TaxesPage from './Tax/TaxesPage';
import TaxesRatesPage from './Tax/TaxesRatesPage';
import AddTaxPage from './Tax/AddTaxPage';
import UpdateTaxRatePage from './Tax/UpdateTaxRatePage';
import TaxGroupsPage from './Tax/TaxGroupsPage';
import AddTaxGroupPage from './Tax/AddTaxGroupPage';
import AddTaxToGroupPage from './Tax/AddTaxToGroupPage';
import UpdateTaxPage from './Tax/UpdateTaxPage';
import UpdateTaxGroupPage from './Tax/UpdateTaxGroupPage';
import RemoveTaxFromGroupPage from './Tax/RemoveTaxFromGroupPage';
/* Category */
import CategoriesPage from './Category/CategoriesPage';
import AddCategoryPage from './Category/AddCategoryPage';
import UpdateCategoryPage from './Category/UpdateCategoryPage';
import InventoryByCategoryReportPage from './Category/InventoryByCategoryReportPage';
/* Product */
import ProductsPage from './Product/ProductsPage';
import ProductToReorderListPage from './Product/ProductToReorderListPage';
import AddProductPage from './Product/AddProductPage';
import ChangeProductPricePage from './Product/ChangeProductSalePricePage';
import ReceiveProductPage from './Product/ReceiveProductPage';
import AdjustProductPage from './Product/AdjustProductPage';
import UpdateProductPage from './Product/UpdateProductPage';
import ProductLabelPage from './Product/ProductLabelPage';
import StocksPage from './Product/StocksPage';
import ProductHistoryPage from "./Product/ProductHistoryPage";
import BatchesPage from "./Product/BatchesPage";
import CorrectReceivedProductPage from "./Product/CorrectReceivedProductPage";
import BulkAddProductPage from "./Product/BulkAddProductPage";
import ReorderPage from "./Product/ReorderPage";
import EnterSoldProductsPage from "./Product/SoldProductsPage";
import ImportProductsPage from './Product/ImportProductsPage';
import ProductsSoldPage from "./Product/ProductsSoldPage";
import ProductsSoldByMonthReport from "./Product/ProductsSoldByMonthReport";
import ArchivedProductsPage from './Product/ArchivedProductsPage';
/* Stock-take */
import StockTakesPage from './StockTake/StockTakesPage';
import TakeStockTakePage from './StockTake/TakeStockTakePage';
import StockTakeDiscrepanciesPage from './StockTake/StockTakeDiscrepanciesPage';
import StockTakeUncountedPage from './StockTake/StockTakeUncountedPage';
import StockTakeHistoryPage from './StockTake/StockTakeHistoryPage';
/* Staff Role */
import AddStaffRolePage from "./StaffRole/AddStaffRolePage";
import UpdateStaffRolePage from "./StaffRole/UpdateStaffRolePage";
import StaffRolesPage from "./StaffRole/StaffRolesPage";
/* Staff */
import StaffsPage from './Staff/StaffsPage';
import AddStaffPage from './Staff/AddStaffPage';
import FireStaffPage from './Staff/FireStaffPage';
import UpdateStaffPage from './Staff/UpdateStaffPage';
/* Salon */
import SalonListPage from './Salon/SalonListPage';
import AddSalonPage from './Salon/AddSalonPage';
import UpdateSalonPage from './Salon/UpdateSalonPage';
/* Brands */
import BrandsPage from './Brand/BrandsPage';
import AddBrandPage from './Brand/AddBrandPage';
import UpdateBrandPage from './Brand/UpdateBrandPage';
/* Suppliers */
import SuppliersPage from './Supplier/SuppliersPage';
import AddSupplierPage from './Supplier/AddSupplierPage';
import UpdateSupplierPage from './Supplier/UpdateSupplierPage';
import SupplierOrdersPage from "./Supplier/SupplierOrdersPage";
import SupplierOrderPage from "./Supplier/SupplierOrderPage";
/* Auth */
import LoginPage from "./Auth/LoginPage";
import LogoutPage from "./Auth/LogoutPage";
/* User */
import UsersPage from './User/UsersPage';
import ChangePasswordPage from './User/ChangePasswordPage';
import AddUserPage from "./User/AddUserPage";
import UpdateUserPage from "./User/UpdateUserPage";
/* Reports */
import CategoriesReport from "./Category/CategoriesReport";
import SuppliersReport from "./Supplier/SuppliersReport";
import ProductToReorderReport from "./Product/ProductToReorderReport";

import logo from "./images/kokopelli-logo.png";
import "./App.css";

import {Alert, Button, Drawer, Icon, Layout, Menu} from 'antd';
import SalonSelector from "./Salon/SalonSelector";

import {version} from './version.js';
import PrivateRoute from "./PrivateRoute";
import Auth from "./services/auth";
import {HIDE_NEW_CONTENT_DRAWER} from "./reducers/appUpdate";
import StartStockTakePage from "./StockTake/StartStockTakePage";
import Screen from './utils/screen';
import BulkStockTakePage from "./StockTake/BulkStockTakePage";
import {bindActionCreators} from "redux";
import {refreshToken} from "./Auth/actions";

const {Header, Content, Footer, Sider} = Layout;
const SubMenu = Menu.SubMenu;

const LandingPage = () => null;

const isNewWindow = window.location.hash === '#NewWindow';

class App extends Component {
  static propTypes = {
    selectedSalonId: PropTypes.string,
    showNewAppContentDrawer: PropTypes.bool.isRequired,
    token: PropTypes.object,
    refreshError: PropTypes.object,
    /* actions */
    hideNewContentDrawer: PropTypes.func.isRequired,
    refreshToken: PropTypes.func.isRequired,
  };

  state = {
    collapsed: false,
    screenWidth: 0,
    authTrigger: 0,
  };

  _auth = Auth.getInstance();

  componentDidMount() {
    Screen.registerWatcher(this.onResize);
    this.checkToken(true);
  }

  componentDidUpdate(prevProps) {
    const {token, refreshError} = this.props;
    if (refreshError && refreshError !== prevProps.refreshError) setTimeout(() => this.checkToken(), 3000);
    else if (token !== prevProps.token) this.checkToken();
  }

  componentWillUnmount() {
    Screen.unregisterWatcher(this.onResize);
  }

  checkToken(firstTime = false) {
    const {refreshToken, token} = this.props;
    this._auth.setRefreshTokenCallback(refreshToken);
    if (token) {
      this._auth.authenticate(token);
    } else if (!firstTime) {
      this._auth.logout();
    } else return;
    this.setState(state => ({ authTrigger: state.authTrigger + 1 }));
  }

  onResize = () => {
    this.setState({screenWidth: Screen.width});
  };

  isMobile = () => this.state.screenWidth <= 768;

  onMenuItemClicked = () => {
    if (this.isMobile()) {
      this.setState({collapsed: true});
    }
  };

  onCloseNewAppContentDrawer = () => {
    this.props.hideNewContentDrawer();
  };

  onClickRefresh = (e) => {
    e.preventDefault();
    window.location.reload(true);
  };

  displayMenu = (...children) => {
    const {collapsed} = this.state;
    if (this.isMobile()) {
      return (
        <Header>
          <Drawer
            placement="left"
            closable={false}
            className="menu-drawer"
            visible={!collapsed}
            width={205}
            height="100%"
            onClose={() => this.setState({collapsed: true})}
          >
            {children}
          </Drawer>
          <Button icon="menu-unfold" onClick={() => this.setState({collapsed: false})} />
          <span>Kokopelli Inventory</span>
        </Header>
      );
    }
    return (
      <Sider width={205}>
        {children}
      </Sider>
    );
  };

  render() {
    const {selectedSalonId} = this.props;
    const auth = this._auth;
    if (!auth.isReady()) return null;
    const isAdmin = auth.hasPermission('admin');
    const canSeeReports = auth.hasPermission('reports');
    const showSider = auth.isAuthenticated() && !isNewWindow;
    const backArrowText = ' Use the back arrow below to close this window.';
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <Layout id="page">
          <Drawer
            placement="top"
            visible={this.props.showNewAppContentDrawer}
            destroyOnClose={true}
            mask={false}
            width="100%"
            height="100"
            onClose={this.onCloseNewAppContentDrawer}
          >
            New version available. Please reload the page.
            &nbsp;
            <Button type="primary" onClick={this.onClickRefresh}>Reload</Button>
          </Drawer>
          {showSider && this.displayMenu(
            <SalonSelector key="salonSelector" auth={auth} />,
            <Menu
                key="menu"
                mode="inline"
                onClick={this.onMenuItemClicked}
            >
              <Menu.Item key="changePassword">
                <Icon type="key"/>
                <span><Link to="/user/changePassword">Change Password</Link></span>
              </Menu.Item>
              <Menu.Item key="logout">
                <Icon type="logout"/>
                <span><Link to="/logout">Logout</Link></span>
              </Menu.Item>
              <SubMenu
                  key="salon"
                  title={<span><Icon type="home"/><span>Salon</span></span>}
              >
                <Menu.Item key="salon-list">
                  <Link to="/salon/list">Salon List</Link>
                </Menu.Item>
              </SubMenu>
              {selectedSalonId && <SubMenu
                key="product"
                title={<span><Icon type="barcode"/><span>Products</span></span>}
              >
                <Menu.Item key="brands">
                  <Link to="/brand/list">Brands</Link>
                </Menu.Item>
                <Menu.Item key="categories">
                  <Link to="/category/list">Categories</Link>
                </Menu.Item>
                <Menu.Item key="products">
                  <Link to="/product/list">Product List</Link>
                </Menu.Item>
                <Menu.Item key="reorder">
                  <Link to="/product/reorder">Reorder</Link>
                </Menu.Item>
                <Menu.Item key="stockTakes">
                  <Link to="/stock-take/list">Stock-takes</Link>
                </Menu.Item>
                <Menu.Item key="suppliers">
                  <Link to="/supplier/list">Suppliers</Link>
                </Menu.Item>
                <Menu.Item key="enterSoldProducts">
                  <Link to="/product/enterSoldProducts">Enter Sold Products</Link>
                </Menu.Item>
                <Menu.Item key="productsSold">
                  <Link to="/product/productsSold">Products Sold</Link>
                </Menu.Item>
                <Menu.Item key="archivedProducts">
                  <Link to="/product/archived">Archive</Link>
                </Menu.Item>
              </SubMenu>}
              <SubMenu key="staff" title={<span><Icon type="team"/><span>Staff</span></span>}>
                {selectedSalonId &&
                <Menu.Item key="staffs">
                  <Link to="/staff/list">Staff</Link>
                </Menu.Item>
                }
                <Menu.Item key="staffRole-list">
                  <Link to="/staff-role/list">Roles</Link>
                </Menu.Item>
              </SubMenu>
              {selectedSalonId && <SubMenu
                  key="tax"
                  title={<span><Icon type="bank"/><span>Taxes</span></span>}
              >
                <Menu.Item key="taxGroups">
                  <Link to="/tax/groups">Groups</Link>
                </Menu.Item>
                <Menu.Item key="taxes">
                  <Link to="/tax/list">Tax List</Link>
                </Menu.Item>
              </SubMenu>}
              {isAdmin &&
              <SubMenu key="users" title={<span><Icon type="laptop"/><span>Users</span></span>}>
                <Menu.Item key="user-list">
                  <Link to="/user/list">User List</Link>
                </Menu.Item>
              </SubMenu>
              }
              {selectedSalonId && canSeeReports &&
              <SubMenu key="reports" title={<span><Icon type="book"/><span>Reports</span></span>}>
                <Menu.Item key="products-sold-by-month-report">
                  <Link to="/product/productsSoldByMonth">Products Sold By Month</Link>
                </Menu.Item>
              </SubMenu>
              }
              <Button type="link" onClick={() => window.open('/manual', '_blank')}>Manual</Button>
            </Menu>
          )}
          <Layout>
            <Content id="content">
              {isNewWindow && (
                <Alert type="warning" message={"A new window was opened to look at data. For concurrency reason we suggest not using this window to change any data. The side menu is also disabled." + backArrowText} />
              )}
              <Switch>
                <PrivateRoute exact path="/" auth={auth} component={LandingPage}/>
                <Route exact path="/login" component={LoginPage}/>
                <Route exact path="/logout" component={LogoutPage}/>
                {/* Salon */}
                <PrivateRoute exact path="/salon/list" auth={auth} component={SalonListPage}/>
                <PrivateRoute exact path="/salon/add" auth={auth} component={AddSalonPage}/>
                <PrivateRoute exact path="/salon/update/:salonId" auth={auth} component={UpdateSalonPage}/>
                {/* Staff Role */}
                <PrivateRoute exact path="/staff-role/list" auth={auth} component={StaffRolesPage}/>
                <PrivateRoute exact path="/staff-role/add" auth={auth} component={AddStaffRolePage}/>
                <PrivateRoute exact path="/staff-role/update/:staffRoleId" auth={auth} component={UpdateStaffRolePage}/>
                {/* Tax */}
                <PrivateRoute exact path="/tax/list" auth={auth} component={TaxesPage}/>
                <PrivateRoute exact path="/tax/rates/:taxId" auth={auth} component={TaxesRatesPage}/>
                <PrivateRoute exact path="/tax/groups" auth={auth} component={TaxGroupsPage}/>
                <PrivateRoute exact path="/tax/add" auth={auth} component={AddTaxPage}/>
                <PrivateRoute exact path="/tax/update-rate/:taxId" auth={auth} component={UpdateTaxRatePage}/>
                <PrivateRoute exact path="/tax/add-group" auth={auth} component={AddTaxGroupPage}/>
                <PrivateRoute exact path="/tax/add-to-group/:taxGroupId" auth={auth} component={AddTaxToGroupPage}/>
                <PrivateRoute exact path="/tax/update/:taxId" auth={auth} component={UpdateTaxPage}/>
                <PrivateRoute exact path="/tax/update-group/:taxGroupId" auth={auth} component={UpdateTaxGroupPage}/>
                <PrivateRoute exact path="/tax/remove-from-group/:taxGroupId" auth={auth} component={RemoveTaxFromGroupPage}/>
                {/* Category */}
                <PrivateRoute exact path="/category/list" auth={auth} component={CategoriesPage}/>
                <PrivateRoute exact path="/category/add" auth={auth} component={AddCategoryPage}/>
                <PrivateRoute exact path="/category/update/:categoryId" auth={auth} component={UpdateCategoryPage}/>
                {/* Product */}
                <PrivateRoute exact path="/product/list" auth={auth} component={ProductsPage}/>
                <PrivateRoute exact path="/product/reorder" auth={auth} component={ReorderPage}/>
                <PrivateRoute exact path="/product/reorder-list" auth={auth} component={ProductToReorderListPage}/>
                <PrivateRoute exact path="/product/add" auth={auth} component={AddProductPage}/>
                <PrivateRoute exact path="/product/bulk-add/:step" auth={auth} component={BulkAddProductPage}/>
                <PrivateRoute exact path="/product/bulk-add" auth={auth} component={BulkAddProductPage}/>
                <PrivateRoute exact path="/product/import" auth={auth} component={ImportProductsPage}/>
                <PrivateRoute exact path="/product/change-price/:productId" auth={auth} component={ChangeProductPricePage}/>
                <PrivateRoute exact path="/product/receive/:productId/:purchaseId" auth={auth} component={ReceiveProductPage}/>
                <PrivateRoute exact path="/product/adjust/:productId/:sku" auth={auth} component={AdjustProductPage}/>
                <PrivateRoute exact path="/product/update/:productId" auth={auth} component={UpdateProductPage}/>
                <PrivateRoute exact path="/product/history/:productId" auth={auth} component={ProductHistoryPage}/>
                <PrivateRoute exact path="/product/label/:productId/:sku" auth={auth} component={ProductLabelPage}/>
                <PrivateRoute exact path="/product/stocks/:productId" auth={auth} component={StocksPage}/>
                <PrivateRoute exact path="/product/batches/:productId/:sku" auth={auth} component={BatchesPage}/>
                <PrivateRoute exact path="/product/correct-batch/:productId/:sku/:receivedAt" auth={auth} component={CorrectReceivedProductPage}/>
                <PrivateRoute exact path="/product/enterSoldProducts" auth={auth} component={EnterSoldProductsPage}/>
                <PrivateRoute exact path="/product/enterSoldProducts/:step" auth={auth} component={EnterSoldProductsPage}/>
                <PrivateRoute exact path="/product/productsSold" auth={auth} component={ProductsSoldPage}/>
                <PrivateRoute exact path="/product/productsSoldByMonth" auth={auth} component={ProductsSoldByMonthReport}/>
                <PrivateRoute exact path="/product/archived" auth={auth} component={ArchivedProductsPage}/>
                {/* Stock-take */}
                <PrivateRoute exact path="/stock-take/list" auth={auth} component={StockTakesPage}/>
                <PrivateRoute exact path="/stock-take/start" auth={auth} component={StartStockTakePage}/>
                <PrivateRoute exact path="/stock-take/take/:stockTakeId" auth={auth} component={TakeStockTakePage}/>
                <PrivateRoute exact path="/stock-take/take/:stockTakeId/:sku" auth={auth} component={TakeStockTakePage}/>
                <PrivateRoute exact path="/stock-take/bulk-take/:stockTakeId" auth={auth} component={BulkStockTakePage}/>
                <PrivateRoute exact path="/stock-take/bulk-take/:stockTakeId/:step" auth={auth} component={BulkStockTakePage}/>
                <PrivateRoute exact path="/stock-take/discrepancies/:stockTakeId" auth={auth} component={StockTakeDiscrepanciesPage}/>
                <PrivateRoute exact path="/stock-take/uncounted/:stockTakeId" auth={auth} component={StockTakeUncountedPage}/>
                <PrivateRoute exact path="/stock-take/history/:stockTakeId" auth={auth} component={StockTakeHistoryPage}/>
                {/* Staff */}
                <PrivateRoute exact path="/staff/list" auth={auth} component={StaffsPage}/>
                <PrivateRoute exact path="/staff/add" auth={auth} component={AddStaffPage}/>
                <PrivateRoute exact path="/staff/fire/:staffId" auth={auth} component={FireStaffPage}/>
                <PrivateRoute exact path="/staff/update/:staffId" auth={auth} component={UpdateStaffPage}/>
                {/* Brand */}
                <PrivateRoute exact path="/brand/list" auth={auth} component={BrandsPage}/>
                <PrivateRoute exact path="/brand/add" auth={auth} component={AddBrandPage}/>
                <PrivateRoute exact path="/brand/update/:brandId" auth={auth} component={UpdateBrandPage}/>
                {/* Suppliers */}
                <PrivateRoute exact path="/supplier/list" auth={auth} component={SuppliersPage}/>
                <PrivateRoute exact path="/supplier/add" auth={auth} component={AddSupplierPage}/>
                <PrivateRoute exact path="/supplier/update/:supplierId" auth={auth} component={UpdateSupplierPage}/>
                <PrivateRoute exact path="/supplier/:supplierId/orders" auth={auth} component={SupplierOrdersPage}/>
                <PrivateRoute exact path="/supplier/order/:supplierOrderId" auth={auth} component={SupplierOrderPage}/>
                {/* User */}
                <PrivateRoute exact path="/user/list" auth={auth} requirePermission="admin" component={UsersPage}/>
                <PrivateRoute exact path="/user/add" auth={auth} requirePermission="admin" component={AddUserPage}/>
                <PrivateRoute exact path="/user/update/:userId" auth={auth} requirePermission="admin" component={UpdateUserPage}/>
                <PrivateRoute exact path="/user/changePassword" auth={auth} component={ChangePasswordPage}/>
                {/* Reports */}
                <PrivateRoute exact path="/reports/inventory-by-category" auth={auth} requirePermission="reports" component={InventoryByCategoryReportPage}/>
                <PrivateRoute exact path="/reports/categories" auth={auth} requirePermission="reports" component={CategoriesReport}/>
                <PrivateRoute exact path="/reports/suppliers" auth={auth} requirePermission="reports" component={SuppliersReport}/>
                <PrivateRoute exact path="/reports/product-to-reorder" auth={auth} requirePermission="reports" component={ProductToReorderReport}/>
              </Switch>
            </Content>
            <Footer id="footer">
              Inventory (rev {version}) ©{new Date().getFullYear()} <img src={logo} className="kokopelli-logo" alt="" />
            </Footer>
          </Layout>
        </Layout>
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  selectedSalonId: state.salon.selectedSalonId,
  showNewAppContentDrawer: state.appUpdate.newAppContentAvailable && !state.appUpdate.hideNewContentDrawer,
  token: state.auth.token,
  refreshError: state.auth.refreshError,
});

const mapDispatchToProps = dispatch => ({
  hideNewContentDrawer: () => (dispatch({type: HIDE_NEW_CONTENT_DRAWER})),
  refreshToken: bindActionCreators(refreshToken, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js